import React from "react";
import { Link } from "react-router-dom";
import { Terminal } from "lucide-react";

function Footer() {
  const getCurrentYear = () => new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-6">
        {/* Footer Grid */}
        <div className="grid md:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <span className="text-xl font-bold">AlgoTurtle</span>
            </div>
            <p className="text-gray-400">
              Empowering traders with intelligent automation since 2020.
            </p>
          </div>

          {/* About Us Links */}
          <div>
            <h3 className="font-semibold mb-4">About Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/" className="hover:text-white">
                  How it works
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white">
                  Investors
                </Link>
              </li>
              <li>
                <Link to="/TermsOfService" className="hover:text-white">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-white">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Us Links */}
          <div>
            <h3 className="font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/qrcard" className="hover:text-white">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/customer-support" className="hover:text-white">
                  Customer Support
                </Link>
              </li>
              <li>
                <Link to="/cancellation" className="hover:text-white">
                  Payment Cancellation & Refund
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white">
                  Destinations
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white">
                  Sponsorships
                </Link>
              </li>
            </ul>
          </div>

          {/* Videos Links */}
          <div>
            <h3 className="font-semibold mb-4">Videos</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link to="/" className="hover:text-white">
                  Demo Video
                </Link>
              </li>
              <li>
                <Link to="/" className="hover:text-white">
                  Tutorials
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media Section */}
        <section className="mt-12">
          <div className="flex flex-col md:flex-row justify-between items-center border-t border-gray-800 pt-8">
            {/* Footer Logo and Rights */}
            <div className="mb-4 md:mb-0 flex justify-center items-center">
              <p className="text-gray-400 text-center">
                AlgoTurtle © {getCurrentYear()}. All rights reserved.
              </p>
            </div>

            {/* Social Media Icons */}
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f" />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram" />
              </a>
              <a
                href="https://www.youtube.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                aria-label="Youtube"
              >
                <i className="fab fa-youtube" />
              </a>
              <a
                href="https://www.twitter.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter" />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin" />
              </a>
            </div>
          </div>
        </section>
      </div>
    </footer>
  );
}

export default Footer;
